import React, {
    ReactNode,
    createContext,
    useContext,
    useState,
    Dispatch,
    SetStateAction,
} from "react";

export interface UpdateContextValue {
    didUpdate: boolean;
    setDidUpdate: Dispatch<SetStateAction<boolean>>;
}

export const UpdateContext = createContext<UpdateContextValue | undefined>(undefined);

export const useUpdateContext = (): UpdateContextValue => {
    const context = useContext(UpdateContext);
    if (!context) {
        throw new Error("useUpdateContext must be used within a UpdateContextProvider");
    }
    return context;
};

interface UpdateContextProviderProps {
    children: ReactNode;
}

const UpdateContextProvider: React.FC<UpdateContextProviderProps> = ({ children }) => {
    const [didUpdate, setDidUpdate] = useState<boolean>(false);

    const contextValue: UpdateContextValue = {
        didUpdate,
        setDidUpdate
    };

    return <UpdateContext.Provider value={contextValue}>{children}</UpdateContext.Provider>;
};

export default UpdateContextProvider;